// @flow
import ChangePassword from './ChangePassword.container';

export default ChangePassword;
